export default __webpack_public_path__ + "static/media/esophagus1.a830acae.jpg";